export default __webpack_public_path__ + "static/media/Run (3).9c8058ce.png";